import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertCategories = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4">
      <h3 className="text-base font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Layers" size={18} />
        فئات التنبيهات
      </h3>
      <div className="space-y-2">
        <button
          onClick={() => onSelectCategory('all')}
          className={`w-full flex items-center justify-between p-3 rounded-lg transition-all duration-250 ${
            selectedCategory === 'all' ?'bg-primary text-primary-foreground shadow-warm' :'bg-muted hover:bg-muted/80 text-foreground'
          }`}
        >
          <div className="flex items-center gap-3">
            <Icon
              name="Inbox"
              size={18}
              className={selectedCategory === 'all' ? 'text-primary-foreground' : 'text-primary'}
            />
            <span className="text-sm font-medium">الكل</span>
          </div>
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-bold ${
              selectedCategory === 'all' ?'bg-primary-foreground/20 text-primary-foreground' :'bg-primary/10 text-primary'
            }`}
          >
            24
          </span>
        </button>
        <button
          onClick={() => onSelectCategory('urgent')}
          className={`w-full flex items-center justify-between p-3 rounded-lg transition-all duration-250 ${
            selectedCategory === 'urgent' ?'bg-primary text-primary-foreground shadow-warm' :'bg-muted hover:bg-muted/80 text-foreground'
          }`}
        >
          <div className="flex items-center gap-3">
            <Icon
              name="AlertCircle"
              size={18}
              className={selectedCategory === 'urgent' ? 'text-primary-foreground' : 'text-primary'}
            />
            <span className="text-sm font-medium">عاجل</span>
          </div>
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-bold ${
              selectedCategory === 'urgent' ?'bg-primary-foreground/20 text-primary-foreground' :'bg-primary/10 text-primary'
            }`}
          >
            8
          </span>
        </button>
        <button
          onClick={() => onSelectCategory('contracts')}
          className={`w-full flex items-center justify-between p-3 rounded-lg transition-all duration-250 ${
            selectedCategory === 'contracts' ?'bg-primary text-primary-foreground shadow-warm' :'bg-muted hover:bg-muted/80 text-foreground'
          }`}
        >
          <div className="flex items-center gap-3">
            <Icon
              name="FileText"
              size={18}
              className={selectedCategory === 'contracts' ? 'text-primary-foreground' : 'text-primary'}
            />
            <span className="text-sm font-medium">العقود</span>
          </div>
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-bold ${
              selectedCategory === 'contracts' ?'bg-primary-foreground/20 text-primary-foreground' :'bg-primary/10 text-primary'
            }`}
          >
            5
          </span>
        </button>
        <button
          onClick={() => onSelectCategory('clients')}
          className={`w-full flex items-center justify-between p-3 rounded-lg transition-all duration-250 ${
            selectedCategory === 'clients' ?'bg-primary text-primary-foreground shadow-warm' :'bg-muted hover:bg-muted/80 text-foreground'
          }`}
        >
          <div className="flex items-center gap-3">
            <Icon
              name="Users"
              size={18}
              className={selectedCategory === 'clients' ? 'text-primary-foreground' : 'text-primary'}
            />
            <span className="text-sm font-medium">العملاء</span>
          </div>
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-bold ${
              selectedCategory === 'clients' ?'bg-primary-foreground/20 text-primary-foreground' :'bg-primary/10 text-primary'
            }`}
          >
            6
          </span>
        </button>
        <button
          onClick={() => onSelectCategory('properties')}
          className={`w-full flex items-center justify-between p-3 rounded-lg transition-all duration-250 ${
            selectedCategory === 'properties' ?'bg-primary text-primary-foreground shadow-warm' :'bg-muted hover:bg-muted/80 text-foreground'
          }`}
        >
          <div className="flex items-center gap-3">
            <Icon
              name="Building2"
              size={18}
              className={selectedCategory === 'properties' ? 'text-primary-foreground' : 'text-primary'}
            />
            <span className="text-sm font-medium">العقارات</span>
          </div>
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-bold ${
              selectedCategory === 'properties' ?'bg-primary-foreground/20 text-primary-foreground' :'bg-primary/10 text-primary'
            }`}
          >
            5
          </span>
        </button>
      </div>
    </div>
  );
};

export default AlertCategories;